import { AgeVerificationStatus } from "@next-platform/packages-ts-types";
/**
 * Returns true when the provided status represents a verified user.
 */
export function isAgeVerificationVerified(status) {
    return !!status && status.toLowerCase() === AgeVerificationStatus.VERIFIED;
}
